/** The meta line under the ad title, shared by the public page and the wizard.
 *
 * Lives apart from main.ts because that module is an entry point — importing it
 * from the app would run the public page's bootstrap.
 */

export interface AdHeaderFacts {
	company_name: string | null;
	location_text: string;
	employment_type: string;
}

/** "Academic Work · Stockholms län · full-time", skipping whatever is blank. */
export function jobMetaLine(job: AdHeaderFacts): string {
	const parts = [
		job.company_name,
		job.location_text,
		job.employment_type.replace("_", "-").toLowerCase(),
	];
	return parts.filter((part): part is string => Boolean(part)).join(" · ");
}

export interface SalaryFacts {
	salary_min: number | null;
	salary_max: number | null;
	salary_currency: string;
	salary_period: string;
}

/** The salary numbers as one public line, or "" when no range is set.
 *
 * Rendered from the structured range the JSON-LD baseSalary uses, so the page
 * and the search-engine payload can never disagree. Grouping follows sv-SE
 * ("60 000"), the market these ads run in.
 */
export function salaryLine(job: SalaryFacts): string {
	const min = job.salary_min;
	const max = job.salary_max;
	const amount = (value: number): string =>
		new Intl.NumberFormat("sv-SE").format(value);
	const per = `${job.salary_currency}/${job.salary_period.toLowerCase()}`;
	if (min !== null && max !== null) return `${amount(min)}–${amount(max)} ${per}`;
	if (min !== null) return `From ${amount(min)} ${per}`;
	if (max !== null) return `Up to ${amount(max)} ${per}`;
	return "";
}
